export interface WindowsService {
    canShutdown: boolean;
    canPauseAndContinue: boolean;
    canStop: boolean;

    displayName: string;
    serviceName: string;
    site: string;
    machineName: string;

    status: ServiceControllerStatusEnum;
    statusString: string;
    serviceType: ServiceTypeEnum;
    serviceTypeString: string;

    servicesDependedOn: string[];
    dependentServices: string[];

    lastCheckPlanningBlocks: Date;
    lastCheckTransportOrders: Date;
}

export enum ServiceControllerStatusEnum {
    Stopped = 1,
    StartPending = 2,
    StopPending = 3,
    Running = 4,
    ContinuePending = 5,
    PausePending = 6,
    Paused = 7
}

export enum ServiceTypeEnum {
    KernelDriver = 1,
    FileSystemDriver = 2,
    Adapter = 4,
    RecognizerDriver = 8,
    Win32OwnProcess = 16,
    Win32ShareProcess = 32,
    InteractiveProcess = 256
}
